// client/src/constants/routes.js

/**
 * Route path constants for the application.
 * Use these instead of hardcoded strings for maintainability.
 */

export const ROUTES = {
  // Dashboard
  DASHBOARD: '/',

  // Leagues
  MY_LEAGUES: '/my-leagues',
  SCHEDULED_MATCHES: '/scheduled-matches',

  // Match-specific routes (functions that return paths)
  matchScore: (leagueId, matchId) =>
    `/leagues/${leagueId}/match/${matchId}/score`,
  matchSchedule: (leagueId, matchId) =>
    `/leagues/${leagueId}/match/${matchId}/schedule`,
  leagueDetail: (leagueId) => `/leagues/${leagueId}`,
}

export default ROUTES
